import { useState } from 'react'

export const useIsTouch = () => {
	const [isTouch] = useState<boolean>(typeof window != 'undefined' && 'ontouchstart' in window)
	return isTouch
}
